<template>
  <div>
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
      <span style="color: #383838;font-size: 14px;font-weight: 700;">已选中{{ num }}个文件/文件夹</span>
    </el-checkbox>
    <div style="margin: 15px 0;"></div>
    <div class="card_list" :style="{ height: tableHeight + 'px' }" v-if="group_list.length > 0">
      <div class="card_list_box" :style="{ backgroundColor: it.checked ? '#F0F2FF' : '' }" v-for="(it, id) in cities"
        :key="it.id">
        <div class="checkout">
          <el-checkbox v-model="it.checked"></el-checkbox>
        </div>
        <div class="card_list_img" @click="rowchang(it)">
          <Fileicon :fileNameURl="it.fpath" :fileSmallPath="it.fileSmallPath" :filetype="it.type"></Fileicon>
        </div>
        <div class="card_text" style="font-size: 14px;">{{ it.folderName }}</div>
        <div class="card_text" style="font-size: 14px;color:#666666">{{ it.updateDate }}</div>
        <el-dropdown style="position: absolute;top: 5px;right: 5px;">
          <span class="card_text_loading" style="background: #fff;padding: 2px 5px;">
            <i class="el-icon-more" style=""></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <div style="display: flex;flex-direction: column;">
              <span class="dropdown-btn"  @click="btnlist(0, it)"><i class="iconfont icon-fenxiang1" style=" color: #4E66FF;"></i> 分享</span>
              <span class="dropdown-btn" @click="btnlist(1, it)"><i class="iconfont icon-xiazai1" style=" color: #4E66FF;"></i> 下载</span>
              <span class="dropdown-btn" @click="btnlist(2, it)"><i class="iconfont icon-shoucang" style=" color: #4E66FF;"></i> 收藏</span>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div v-else>
      <div class="no_data_area" style="height: 100%;margin: 20% 0 0 0;">
        <div class="no_data"></div>
        <div class="no_staff">
          <span>暂无相关数据</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    group_list: {
      type: Array,
      default: () => []
    },
    selectionlist: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    group_list: {
      handler(newval, oldval) {
        this.cities = newval
      },
      deep: true
    },
    selectionlist: {
      handler(newVal, oldVal) {
        this.selectionlists = newVal
      }
    },
    cities: {
      handler(newval, oldval) {
        let ary = []
        this.cities.forEach(element => {
          if (element.checked) {
            ary.push(element)
          }
        })
        this.$emit("handleSelectionChange", ary)
        this.num = ary.length
        if (ary.length > 0) {
          if (ary.length == this.cities.length) {
            this.checkAll = true
          } else {
            this.checkAll = false
          }
        } else {
          this.checkAll = false
        }
      },
      deep: true
    },
  },
  data() {
    return {
      cities: this.group_list,
      selectionlists: this.selectionlist,
      checkAll: false,
      isIndeterminate: false,
      checkedCities: [],
      // 选中数量
      num: 0,
      // 高度
      tableHeight: 0,
    }
  },
  created() {
    // 100是表格外其它布局占的高度，这个数值根据自己实际情况修改
    this.tableHeight = window.innerHeight - this.Height
  },
  mounted() {
    let _this = this

    // 设置表格高度
    this.tableHeight = window.innerHeight - this.Height
    // / 监听浏览器窗口变化，动态计算表格高度，
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - this.Height
      })()
    }
  },
  computed: {},
  methods: {
    btnlist(type, obj) {
      let _this = this
      _this.$emit('btncardlist', type, obj)
    },
    // 选中下级
    rowchang(it) {
      this.$emit('rowchang', it)
    },
    // 全选反选
    handleCheckAllChange(val) {
      let ary = []
      if (val) {
        this.cities.forEach(element => {
          element.checked = true
          ary.push(element)
        })
      } else {
        this.cities.forEach(element => {
          element.checked = false
        })
        ary = []
      }
      this.$emit("handleSelectionChange", ary)
    },
  },
}
</script>
<style lang='less' scoped>
.el-checkbox {
  padding: 0 0 0 5px;
  position: relative;
}




.card_list{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); /* 自动换行 */
  grid-gap: 10px; /* 垂直间距50px，水平间距20px */
}

.card_list_box {
  padding: 10px;
  width: 180px;
  height: 200px;
  background: #f5f5f56e;
  // margin: 0 10px 10px 0;
  position: relative;
  border-radius: 10px;
  // float: left;


  .checkout {
    position: absolute;
    top: 5px;
    left: 5px;
  }

  .card_list_img {
    width: 100px;
    height: 100px;
    margin: 20px auto 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .card_text {
    margin-top: 5px;
    text-align: center;
    line-height: 15px;
    // 下面才是重点关注代码
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 1;
    /* 设置最大显示行数 */
    word-wrap: break-word;
  }
}

.card_text_loading {
  display: none;
}

.card_list_box:hover {
  padding: 10px;
  width: 180px;
  height: 200px;
  background: #F0F2FF;
  position: relative;
  border-radius: 10px;

  .card_text_loading {
    display: block;
  }
}
.dropdown-btn{
  background: #fff;
  font-size: 14px;
  padding: 10px 20px;
  cursor: pointer;
  color: #4E66FF;
}

.dropdown-btn:hover{
  background-color: #ecf5ff;
}

</style>
